import { ActionPlugin } from '../Action/plugin'
import { ActionCallVariableNode } from './TypedNode'

import type { RehajePlugin } from '@rehaje/core'

export class ActionCallVariablePlugin implements RehajePlugin {
  constructor() {
    return new ActionPlugin({
      actions: {
        CallVariable: ActionCallVariableNode
      }
    })
  }
}
